export const BOOKING_LIST_REQUEST = 'BOOKING_LIST_REQUEST';
export const BOOKING_LIST_SUCCESS = 'BOOKING_LIST_SUCCESS';

export const BOOKING_REQUEST = 'BOOKING_REQUEST';
export const BOOKING_SUCCESS = 'BOOKING_SUCCESS';

export const BOOKING_CHANGE_APPOINTMENT_REQUEST = 'BOOKING_CHANGE_APPOINTMENT_REQUEST';
export const BOOKING_CHANGE_APPOINTMENT_SUCCESS = 'BOOKING_CHANGE_APPOINTMENT_SUCCESS';

export const BOOKING_UPDATE_STATUS_REQUEST = 'BOOKING_UPDATE_STATUS_REQUEST';
export const BOOKING_UPDATE_STATUS_SUCCESS = 'BOOKING_UPDATE_STATUS_SUCCESS';

export const BOOKING_CANCEL_REQUEST = 'BOOKING_CANCEL_REQUEST';
export const BOOKING_CANCEL_SUCCESS = 'BOOKING_CANCEL_SUCCESS';

export const BOOKING_SETTINGS_CANCEL_REASONS_REQUEST = 'BOOKING_SETTINGS_CANCEL_REASONS_REQUEST';
export const BOOKING_SETTINGS_CANCEL_REASONS_SUCCESS = 'BOOKING_SETTINGS_CANCEL_REASONS_SUCCESS';

export const BOOKING_ERROR = 'BOOKING_ERROR';
